export const setupSegment = () => {
  const segmentSourceId = import.meta.env.REACT_APP_SEGMENT_SOURCE_ID;

  if (window.analytics.load) {
    window.analytics.load(segmentSourceId);
  }
};
